module.exports = __webpack_public_path__ + "img/gont_3.b4138628.jpg";